/**
 * File: queryClientUtils.ts
 * Path: apps/admin/src/modules/app/queryClientUtils.ts
 * Description: The admin's React Query client and its cache times.
 */

import { QueryClient } from '@tanstack/react-query';
import { ACCOUNTING_COLLECTIONS, CONTRACT_COLLECTIONS } from '@idk/config';

/** Kept longer: these change only through this admin, which refreshes them itself. */
const OWN_DATA_STALE_MS = 5 * 60 * 1000;

export const createQueryClient = (): QueryClient => {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });
  // The books (every journal and bank line) are the admin's biggest reads.
  // Every change goes through useBooksCommand or a contract payment, and both
  // refresh what they touched, so re-reading them each minute bought nothing.
  client.setQueryDefaults([ACCOUNTING_COLLECTIONS.profiles], { staleTime: OWN_DATA_STALE_MS });
  // Payments and due dates per contract: the Today page reads two per signed
  // contract. Only the payment buttons change them, and those refresh them.
  client.setQueryDefaults([CONTRACT_COLLECTIONS.contracts, 'payments'], { staleTime: OWN_DATA_STALE_MS });
  client.setQueryDefaults([CONTRACT_COLLECTIONS.contracts, 'receipts'], { staleTime: OWN_DATA_STALE_MS });
  client.setQueryDefaults([CONTRACT_COLLECTIONS.contracts, 'dueDates'], { staleTime: OWN_DATA_STALE_MS });
  return client;
};
